// extracted by mini-css-extract-plugin
export default {"popup-panel-wrapper":"popup-panel-wrapper__WOgoY","popup-panel-title":"popup-panel-title__hlaZW"};